import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Form, Input, Checkbox } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { useAuth } from '../../authContext/AuthContext';
import { Noti } from '../../components/Noti/toast';
import './style.scss';

const REMEMBER_ME_KEY = 'rememberedLogin';
const REMEMBER_ME_EMAIL_KEY = 'rememberedEmail';
const REMEMBER_ME_PASSWORD_KEY = 'rememberedPassword';

const LoginPage = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    // Kiểm tra xem có thông tin đăng nhập đã lưu không
    const savedRememberMe = localStorage.getItem(REMEMBER_ME_KEY);
    if (savedRememberMe === 'true') {
      const savedEmail = localStorage.getItem(REMEMBER_ME_EMAIL_KEY);
      const savedPassword = localStorage.getItem(REMEMBER_ME_PASSWORD_KEY);

      if (savedEmail && savedPassword) {
        form.setFieldsValue({
          email: savedEmail,
          password: savedPassword,
        });
        setRememberMe(true);
      }
    }
  }, [form]);

  const onFinish = async (values: { email: string; password: string }) => {
    setLoading(true);
    try {
      await login(values.email, values.password);

      // Lưu thông tin đăng nhập nếu remember me được chọn
      if (rememberMe) {
        localStorage.setItem(REMEMBER_ME_KEY, 'true');
        localStorage.setItem(REMEMBER_ME_EMAIL_KEY, values.email);
        localStorage.setItem(REMEMBER_ME_PASSWORD_KEY, values.password);
      } else {
        // Xóa thông tin đã lưu nếu không chọn remember me
        localStorage.removeItem(REMEMBER_ME_KEY);
        localStorage.removeItem(REMEMBER_ME_EMAIL_KEY);
        localStorage.removeItem(REMEMBER_ME_PASSWORD_KEY);
      }

      Noti('success', 'Login success', 3000);
      navigate('/dashboard');
    } catch (error: any) {
      Noti('error', error.message || 'Login failed', 3000);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-container">
        <div className="auth-header">
          <h1 className="auth-title">Login</h1>
          <p className="auth-subtitle">Welcome back! Please login to your account.</p>
        </div>

        <Form
          form={form}
          name="login"
          onFinish={onFinish}
          layout="vertical"
          size="large"
          className="auth-form"
        >
          <Form.Item
            name="email"
            label="Email"
            rules={[
              { required: true, message: 'Please enter your email!' },
              { type: 'email', message: 'Email is not valid!' },
            ]}
          >
            <Input
              prefix={<UserOutlined />}
              placeholder="Enter your email"
              autoComplete="email"
            />
          </Form.Item>

          <Form.Item
            name="password"
            label="Password"
            rules={[{ required: true, message: 'Please enter your password!' }]}
          >
            <Input.Password
              prefix={<LockOutlined />}
              placeholder="Enter your password"
              autoComplete="current-password"
            />
          </Form.Item>

          <Form.Item>
            <Checkbox
              checked={rememberMe}
              onChange={(e) => setRememberMe(e.target.checked)}
              className="remember-me-checkbox"
            >
              Remember me
            </Checkbox>
          </Form.Item>

          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              className="auth-button"
              loading={loading}
              block
            >
              Login
            </Button>
          </Form.Item>
        </Form>

        {/* <div className="auth-footer">
          <p>
            Don't have an account?{' '}
            <Link to="/register" className="auth-link">
              Register now
            </Link>
          </p>
        </div> */}

        {/* <div className="auth-demo-info">
          <p className="demo-title">Demo accounts:</p>
          <div className="demo-accounts">
            <div className="demo-account">
              <strong>Admin:</strong> admin@example.com / admin123
            </div>
            <div className="demo-account">
              <strong>User:</strong> user@example.com / user123
            </div>
          </div>
        </div> */}
      </div>
    </div>
  );
};

export default LoginPage;

